import { unifiedAgentEvent } from './unifiedAgentEvent'

export const unifiedAgentDisabledLogEvent = unifiedAgentEvent<{
  agent_id: number
}>('Unified_Agent_Disabled')
